
function getLang() {
    var lang =(navigator.browserLanguage || navigator.language ).toLowerCase();//常规浏览器语言和IE浏览器
    lang = lang.substr(0, 2);//截取lang前2位字符
    console.log(lang);
    if(lang === 'en'){
        console.log(lang);
         return 'en';
      }
    else{
         return 'zh';
      }
}

module.exports = {
    getLang
}


// WEBPACK FOOTER //
// ./src/lang.js